<template>
  <r-toggle-card
    title="Высота"
    :is-open="layerStyle.fillExtrusion.enabled"
    @toggle="toggleFillExtrusion"
  >
    <div class="fill-extrusion-picker">
      <div class="fill-extrusion-picker__simple">
        <r-slider
          title="Размер"
          :number="layerStyle.fillExtrusion.paint['fill-extrusion-height']"
          :min="50"
          :max="10000"
          :step="10"
          @change="changeProperty('fill-extrusion-height', $event)"
        />
      </div>
      <div class="fill-extrusion-picker__more-block">
        <div class="fill-extrusion-picker__attributes">
          <r-text type="caption" style="margin-bottom: 4px;">
            Зависит от атрибута
          </r-text>
          <source-attributes
            :single="true"
            :active-fields="field"
            @handleNodeClick="changeField($event)"
            :tree-data="getAttributes(objectFields, false, false)"
          />
        </div>
      </div>
    </div>
  </r-toggle-card>
</template>

<script>
import SourceAttributes from "@/components/map/components/source-attributes/source-attributes";
import { getAttributes } from "@/utils";

export default {
  props: [
    "id",
    "layer-style",
    "style-controller",
    "layer-controller",
    "property",
    "title"
  ],
  components: {
    SourceAttributes
  },
  watch: {
    id: function() {
      const path = this.getConfigValue("field");
      this.fieldMin = this.getConfigValue("fieldMin");
      this.fieldMax = this.getConfigValue("fieldMax");
      this.objectFields = this.$clientStore.getDataFields(
        this.$store.state.profiles.sourceIdById[this.id]
      );

      if (path) this.changeField({ path });
      else {
        this.field = "";
        this.changeField({ path });
      }
    }
  },
  data() {
    return {
      moreShown: false,
      objectFields: this.$clientStore.getDataFields(
        this.$store.state.profiles.sourceIdById[this.id]
      ),
      field: this.getConfigValue("field") || "",
      fieldMin: this.getConfigValue("fieldMin") || 0,
      fieldMax: this.getConfigValue("fieldMax") || 0
    };
  },
  methods: {
    getConfigValue(field) {
      return this.$store.state.map.styleConfig[this.id].fillExtrusion[field];
    },
    toggleFillExtrusion(value) {
      this.layerStyle.fillExtrusion.enabled = value;

      this.styleController.toggleFillExtrusion(this.id);
    },
    changeProperty(property, value) {
      if (value) this.layerStyle.fillExtrusion.paint[property] = value;

      if (!this.field)
        this.styleController.changeFillExtrusionProperty(this.id, property);
      else this.applyRange();
    },
    async changeField({ path }) {
      if (path === this.field) {
        this.field = "";
        this.fieldMin = 0;
        this.fieldMax = 0;
        this.changeProperty("fill-extrusion-height");
        this.$store.commit("SET_FILL_EXTRUSION_STYLE", {
          id: this.id,
          config: {
            field: this.field,
            fieldMax: this.fieldMax,
            fieldMin: this.fieldMin,
            enabled: this.getConfigValue("enabled")
          }
        });
      } else {
        this.field = path;
        await this.layerController.updateLayerData(this.id, [this.field]);
        this.setMinMaxValues();
        this.$store.commit("SET_FILL_EXTRUSION_STYLE", {
          id: this.id,
          config: {
            field: this.field,
            fieldMax: this.fieldMax,
            fieldMin: this.fieldMin,
            enabled: this.getConfigValue("enabled")
          }
        });
        this.applyRange();
      }
    },
    setMinMaxValues() {
      const field = this.field;
      const attributes = this.$clientStore.getDataFields(
        this.$store.state.profiles.sourceIdById[this.id]
      );
      const attribute = attributes.find(f => f.title === field);
      if (!attribute) return;
      const { min, max } = attribute;
      this.fieldMin = min;
      this.fieldMax = max;
    },
    applyRange() {
      this.styleController.changeFillExtrusionRange(
        this.id,
        "fill-extrusion-height"
      );
    },
    getAttributes
  }
};
</script>

<style lang="scss">
.fill-extrusion-picker {
  &__attributes {
    margin-top: 16px;
  }
}
</style>
